import React, { useState } from "react";
import { cn } from "../../utils/cn";
import Icon from "../AppIcon";

const Accordion = ({ items, className }) => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className={cn("space-y-4", className)}>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? null : index)}
        />
      ))}
    </div>
  );
};

const AccordionItem = ({ item, isOpen, onToggle }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-muted transition-colors"
      >
        <span className="font-semibold text-text-primary pr-4">{item.question}</span>
        <Icon
          name={isOpen ? "ChevronUp" : "ChevronDown"}
          size={20}
          className="text-text-secondary flex-shrink-0 transition-transform"
        />
      </button>
      {isOpen && (
        <div className="px-6 py-4 border-t border-gray-200 bg-muted/50">
          <p className="text-text-secondary">{item.answer}</p>
        </div>
      )}
    </div>
  );
};

export default Accordion;





